import useSWR from 'swr'
import { Instruction_Book } from '@graphql/queries'

const useInstructionBook = () => {
  const { data, error, mutate, isValidating } = useSWR(Instruction_Book)

  return {
    book: data?.instructionBook,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useInstructionBook }
